import { render } from "./delivery_date.vue?vue&type=template&id=6448cd21"
import script from "./delivery_date.vue?vue&type=script&lang=js"
export * from "./delivery_date.vue?vue&type=script&lang=js"

import exportComponent from "/home/raphael/git/proclima/retailerportal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__